(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-selector"] && !Shopify.designMode) return;
  try {
    // Shopify bundles this block into a single asset, so it runs once per page
// rather than once per render of the snippet, and its contents are not
// Liquid-rendered (no section id available here). It is mounted on the product
// section root so it re-binds when that section reloads in the editor.
Torrini.section('.product', function (root, ctx) {
  // Size dropdown selection
  const sizeDropdowns = document.querySelectorAll('[data-variant-option-dropdown]');
  const sizeButtons = document.querySelectorAll('.product__select-size-btn');
  const selectedValueElements = document.querySelectorAll('[data-selected-value-for]');

  if (sizeDropdowns.length) {
    sizeDropdowns.forEach((dropdown, index) => {
      ctx.on(dropdown, 'change', e => {
        const selectedValue = dropdown.value;
        const optionIndex = dropdown.closest('[data-product-variant-option]').dataset.optionIndex;
        const sizeButton = sizeButtons[index];
        
        // Update size button text
        if (selectedValue && sizeButton) {
          const textSpan = sizeButton.querySelector('.size-btn-text');
          if (textSpan) {
            textSpan.textContent = selectedValue;
          }
        } else if (sizeButton) {
          const textSpan = sizeButton.querySelector('.size-btn-text');
          if (textSpan) {
            textSpan.textContent = sizeButton.dataset.defaultText || 'Select Size';
          }
        }
        
        // Update selected value text
        selectedValueElements.forEach(el => {
          if (el.dataset.optionIndex === optionIndex) {
            el.textContent = selectedValue;
          }
        });
        
        // Find matching variant and update
        if (typeof getSelectedOptions === 'function' && typeof findMatchingVariant === 'function') {
          const selectedOptions = getSelectedOptions();
          const matchedVariant = findMatchingVariant(selectedOptions);
          
          if (typeof updateVariant === 'function') {
            updateVariant(matchedVariant);
          }
        }
        
        // Dispatch variant change event for delivery date update
        document.dispatchEvent(new CustomEvent('variant:change', {
          detail: { optionValue: selectedValue }
        }));
      });
    });
  }
  
  // Listen for size selection from size guide drawer.
  //
  // ctx.on, not document.addEventListener: document outlives this section, so a
  // direct binding is never torn down and every shopify:section:load in the
  // theme editor left another permanent copy behind, each one re-running the
  // handler. Same contract as the dropdown binding above.
  ctx.on(document, 'size:selected', function(e) {
    if (e.detail && (e.detail.value || e.detail.size)) {
      const selectedSize = e.detail.value || e.detail.size;
      const sizeDropdown = document.querySelector('[data-variant-option-dropdown]');
      const sizeButton = document.querySelector('.product__select-size-btn');
      
      if (sizeButton) {
        const textSpan = sizeButton.querySelector('.size-btn-text');
        if (textSpan) {
          textSpan.textContent = selectedSize;
        }
      }
      
      if (sizeDropdown) {
        sizeDropdown.value = selectedSize;
        sizeDropdown.dispatchEvent(new Event('change', { bubbles: true }));
      }
      
      // Dispatch variant change event for delivery date update
      document.dispatchEvent(new CustomEvent('variant:change', {
        detail: { optionValue: selectedSize }
      }));
    }
  });
});
  } catch(e) { console.error(e); }
})();

})();
